export default function AboutVox2youSection() {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Sobre a <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F19E1A] to-[#e08d0f]">Vox2you</span>
          </h2>
        </div>

        {/* Layout em 2 colunas equilibradas */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start mb-12">
          {/* Coluna Esquerda - Card de Conteúdo (3 colunas) */}
          <div className="lg:col-span-3 order-2 lg:order-1">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-10 shadow-2xl h-full flex flex-col justify-center">
              <div className="space-y-6">
                <div className="flex justify-center lg:justify-start mb-4">
                  <img 
                    src="https://vox2you.com.br/wp-content/uploads/2023/07/Export_Selo-10-anos__colorido-completo-copia-2.png" 
                    alt="Vox2You 10 anos" 
                    className="h-24 w-auto"
                  />
                </div>
                
                <p className="text-xl leading-relaxed font-medium">
                  A Vox2you é hoje uma das <strong className="text-[#F19E1A]">maiores escolas de comunicação da América Latina</strong>, com milhares de alunos impactados em todo o Brasil.
                </p>
                
                <p className="text-base text-gray-300 leading-relaxed">
                  A metodologia foi criada para desenvolver comunicação de forma <strong>prática</strong>, <strong>dinâmica</strong> e <strong>transformadora</strong>, ajudando pessoas a falarem com mais clareza, confiança e influência.
                </p>

                <div className="pt-6 border-t border-gray-700">
                  <p className="text-base text-gray-400 italic">
                    "Transformando vidas através da comunicação há mais de 10 anos"
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Coluna Direita - Foto (2 colunas) */}
          <div className="lg:col-span-2 order-1 lg:order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F19E1A]/20 to-[#e08d0f]/20 rounded-2xl blur-xl"></div>
              <div className="relative overflow-hidden rounded-2xl shadow-2xl border-4 border-white">
                <img
                  src="/images/voxday/proprietarios.jpeg"
                  alt="Proprietários Vox2You"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <i className="ri-trophy-line text-[#F19E1A] text-5xl mb-3 inline-block"></i>
            <p className="text-xl font-semibold text-gray-900 mb-1">+10 anos</p>
            <p className="text-gray-600 text-sm">de experiência</p>
          </div>
          
          <div className="text-center">
            <i className="ri-team-line text-[#F19E1A] text-5xl mb-3 inline-block"></i>
            <p className="text-xl font-semibold text-gray-900 mb-1">+130 mil</p>
            <p className="text-gray-600 text-sm">alunos transformados</p>
          </div>
          
          <div className="text-center">
            <i className="ri-map-pin-line text-[#F19E1A] text-5xl mb-3 inline-block"></i>
            <p className="text-xl font-semibold text-gray-900 mb-1">América Latina</p>
            <p className="text-gray-600 text-sm">referência em oratória</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-lg font-bold text-gray-900 bg-gray-50 rounded-lg p-5 max-w-3xl mx-auto">
            Agora você terá a oportunidade de <span className="text-[#F19E1A]">viver essa experiência</span> na prática.
          </p>
        </div>
      </div>
    </section>
  );
}
